import { type UseQueryResult, useQuery } from 'react-query';
import { PsuAwardService } from '@wealthlane/api-services/wealthlane-award-service';

const useGetGrantPsuList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string;
    }>
  | undefined,
  unknown
> => {
  const grantPsuOptions = useQuery(
    ['getGrantPsuOptions'],
    async () => {
      return await handleRequest(PsuAwardService.getApiAwardApiAppPSUAwardUpcomingGrantList());
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.grantName ?? '',
            value: item.grantId ?? '',
          };
        });
      },
    }
  );

  return grantPsuOptions;
};

export default useGetGrantPsuList;
